<script>
import { mask } from 'vue-the-mask';
import { required } from 'vuelidate/lib/validators';
import EditableText from '@components/editables/editable-text.vue';
import {
  authComputed,
  authMethods,
  trainerMethods,
  adminPanelComputed,
  adminPanelMethods,
  organizationComputed,
} from '@state/helpers';

export default {
  components: { EditableText },
  directives: { mask },
  props: {},
  data() {
    return {
      pricingTypes: [
        { label: 'Recurring', value: 'recurring' },
        { label: 'Single', value: 'single' },
      ],
      billingTypes: [
        { label: 'Weekly', value: 'weekly' },
        { label: 'Monthly', value: 'monthly' },
        { label: 'Annually', value: 'annually' },
      ],
      submitting: false,
      price: {
        name: '',
        type: 'Single',
        amount: null,
        accessLength: 1,
      },
      isSubscription: 'no',
      componentKey: 0,
      weeksOpts: this.getWeeks(1, 60, 1),
    };
  },
  validations: {
    price: {
      name: {
        required,
      },
      amount: {
        required,
      },
      type: {
        required,
      },
      accessLength: {
        required,
      },
    },
  },
  computed: {
    ...authComputed,
    ...adminPanelComputed,
    ...organizationComputed,
    accessLengthValue() {
      let value = this.price.accessLength;
      if (this.price.accessLength && this.price.accessLength === 1) {
        value = `${this.price.accessLength} Week`;
      }
      if (this.price.accessLength && this.price.accessLength > 1) {
        value = `${this.price.accessLength} Weeks`;
      }
      return value;
    },
  },
  methods: {
    ...trainerMethods,
    ...authMethods,
    ...adminPanelMethods,
    submit() {
      this.submitting = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const priceObj = this.price;
        priceObj.productId = this.currentUser.trainer.myProducts[0].id;
        this.createTrainerProductPrice({
          trainerId: this.currentUser.trainer._id,
          priceObj: { price: priceObj },
        })
          .then(async (res) => {
            if (res.success) {
              this.price = { name: '', type: '', amount: 0.0, accessLength: 1 };
              this.addPrice(res.product);
              this.setHideAdminPanel();
            } else {
              console.warn(res.message);
            }
            this.submitting = false;
          })
          .catch((err) => {
            console.warn(err);
            this.submitting = false;
          });
      } else {
        this.submitting = false;
      }
    },
    onPriceTypeChange(value) {
      this.price.type = value.label;
    },
    setPriceName(val) {
      this.price.name = val;
    },
    toggled(e) {
      this.isSubscription = e.target.checked ? 'yes' : 'no';
      if (e.target.checked) {
        this.price.type = 'Recurring';
      }
      if (!e.target.checked) {
        this.price.type = 'Single';
      }
    },
    onPriceAccessLengthChange(e) {
      this.price.accessLength = e.value;
    },
    resetForm() {
      this.submitting = false;
      this.price = {
        name: '',
        type: 'Single',
        amount: null,
        accessLength: 1,
      };
      this.isSubscription = 'no';
      if (this.$refs && this.$refs.inputToggleInput) {
        this.$refs.inputToggleInput.checked = false;
      }
      this.componentKey++;
      this.$v.$reset();
    },
    getWeeks(start, stop, step = 1) {
      return new Array(stop / step).fill(start).map((n, i) => {
        return {
          label: `${(i + 1) * step} ${(i + 1) * step === 1 ? 'Week' : 'Weeks'}`,
          value: (i + 1) * step,
        };
      });
    },
  },
  watch: {
    isAdminPanelActive(val) {
      if (!val) {
        this.resetForm();
      }
    },
    '$v.$invalid': {
      handler(val) {
        if (!val) {
          this.$v.$touch();
        }
      },
    },
  },
};
</script>

<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="col">
        <label>Product Title</label>
        <EditableText
          name="price-name"
          placeholderTxt="Start typing.."
          mode="edit"
          :text="price.name"
          :canEdit="true"
          @update-editable-value="setPriceName"
        />
        <p v-if="$v.price.name.$error" class="error">
          Product title is required.
        </p>
      </div>
    </div>
    <div class="row">
      <div
        class="col"
        :class="[
          {
            'select-error': $v.price.type.$error,
          },
        ]"
      >
        <label for="product_type">Subscription</label>
        <div class="custom-control custom-switch">
          <input
            ref="inputToggleInput"
            type="checkbox"
            class="custom-control-input"
            id="customSwitches"
            @input="toggled"
          />
          <label
            ref="inputToggleLabel"
            :class="[
              'custom-control-label',
              { isSubscription: isSubscription === 'yes' ? true : false },
            ]"
            for="customSwitches"
            ><span class="isSub">{{ isSubscription }}</span></label
          >
        </div>
      </div>
    </div>
    <!-- WE MIGHT USE THIS LATER -->
    <!-- <div :class="['billing-row row', { disabled: isSubscription === 'no' }]">
      <div
        class="col-5"
        :class="[
          {
            'select-error': $v.price.accessLength.$error,
          },
        ]"
      >
        <label for="price_interval">Billing</label>
          <v-select
          :options="billingTypes"
          :searchable="false"
          :clearable="false"
          :value="accessLengthSubValue"
          @input="onPriceAccessLengthChange"
        />
      </div>
      <div
        class="col-6"
        :class="[
          {
            'input-error': $v.price.amount.$error,
          },
        ]"
      >
        <label>Price</label>
        <EditableText
          :key="componentKey"
          name="price-name"
          type="number"
          placeholderTxt="20.00"
          mode="edit"
          :text="price.amount ? '$' + price.amount : price.amount"
          pattern="^\d*(\.\d{0,2})?$"
          @update-editable-value="price.amount = $event
              ? parseFloat($event)
              : null"
        />
      </div>
    </div> -->
    <div
      :class="[
        'duration-row row',
        { disabled: isSubscription !== 'yes' && isSubscription !== 'no' },
      ]"
    >
      <div
        class="col-5"
        :class="[
          {
            'select-error': $v.price.accessLength.$error,
          },
        ]"
      >
        <label for="price_interval">Duration</label>
        <v-select
          :options="weeksOpts"
          :searchable="false"
          :clearable="false"
          :value="accessLengthValue"
          @input="onPriceAccessLengthChange"
        />
      </div>
      <div class="col-6">
        <label>Price</label>
        <div class="price-wrapper">
          <span :class="['dollar-sign', { empty: !price.amount }]">$</span>
          <BaseInputText
            type="number"
            name="price-price"
            :value="price.amount"
            placeholder="20.00"
            min="0"
            step=".50"
            pattern="^\d*(\.\d{0,2})?$"
            @input="
              price.amount = $event.target.value
                ? parseFloat($event.target.value)
                : null
            "
          />
        </div>
        <p v-if="$v.price.amount.$error" class="error">
          Price is required.
        </p>
      </div>
      <div class="col-9">
        <p v-if="isSubscription === 'yes'"
          >Client billed ${{ price.amount ? price.amount : 0 }} every
          {{ accessLengthValue === '1 Week' ? 'Week' : accessLengthValue }} and
          has access until the {{ organizationTitle }} PAY is cancelled.</p
        >
        <p v-if="isSubscription === 'no'"
          >Client charge ${{ price.amount ? price.amount : 0 }} once and has
          access to {{ organizationTitle }} TRAIN for
          {{ accessLengthValue }}.</p
        >
      </div>
    </div>
    <div :class="['panel-footer', { 'form-error': $v.$error }]">
      <span class="divider-vertical">&nbsp;</span>
      <BaseButton
        type="button"
        class="btn-primary btn-clear btn-cancel"
        @click="resetForm"
      >
        Cancel
      </BaseButton>
      <BaseButton
        :style="{ opacity: submitting ? 0.6 : 1 }"
        :disabled="submitting"
        type="submit"
        class="btn-primary btn-clear"
      >
        <BaseIcon v-if="submitting" name="sync" spin />
        <BaseIcon v-if="!submitting" name="save" />
        Save Changes
      </BaseButton>
    </div>
  </form>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable selector-max-type

::v-deep .input-inline-edit {
  font-size: 2.5rem;
  line-height: 5rem;
}

.price-wrapper {
  align-items: center;
  border-bottom: 1px solid rgba($color-gray-wo-rgb, 0.4);
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  width: fit-content;
  .dollar-sign {
    color: black;
    font-size: 2.2rem;
    font-weight: 900;
    text-align: center;
    &.empty {
      color: rgba($color-black-wo-rgb, 0.5);
    }
  }
  ::v-deep .input {
    background-color: white;
    border: unset;
    color: $color-black-one;
    font-size: 2.3rem;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.761905px;
    line-height: 4.3rem;
    margin-bottom: 0;
    outline: unset;
    padding: unset;
  }
  ::v-deep .input-inline-edit {
    border-bottom: unset;
  }
  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: rgba($color-black-wo-rgb, 0.5);
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba($color-black-wo-rgb, 0.5);
  }
  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: rgba($color-black-wo-rgb, 0.5);
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: rgba($color-black-wo-rgb, 0.5);
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgba($color-black-wo-rgb, 0.5);
  }
  ::placeholder {
    /* Most modern browsers support this now. */
    color: rgba($color-black-wo-rgb, 0.5);
  }
}

.billing-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem !important;
  margin-top: 5rem;
  ::v-deep .input-inline-edit {
    line-height: 4rem;
  }
  .col-6 {
    flex: 0 0 53%;
    max-width: 53%;
  }
  &.disabled {
    opacity: 0.4;
    pointer-events: none;
  }
}
.duration-row {
  @extend .billing-row;

  .col-8 {
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    line-height: 24px;
  }

  margin-bottom: 10rem !important;
  margin-top: 5rem;
  &.disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::v-deep input[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }
}
.isSub {
  color: $color-black-one;
  font-size: 18px;
  font-weight: normal;
  left: 6rem;
  letter-spacing: 0.275px;
  line-height: 21px;
  position: absolute;
  text-transform: lowercase;
  top: 1rem;
}

.custom-control {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: 0 !important;
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */

  /* Rules below not implemented in browsers yet */
  -o-user-select: none;
  user-select: none;
}
.custom-control-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: unset;
  outline: 0 !important;
  width: 6.5rem !important;
}
.custom-control-label {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: unset;
  cursor: pointer;
  font-size: 3rem;
  outline: 0 !important;
  &:focus {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: unset;
    border-color: unset !important;
    outline: 0 !important;
  }
  &::before {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: $color-off-white !important;
    border: unset;
    border-color: unset !important;
    border-radius: 3.5rem;
    box-shadow: inset 0 4px 4px rgba($color-black-wo-rgb, 0.06);
    height: 3.5rem !important;
    outline: 0 !important;
    width: 6.5rem !important;
  }
  &::after {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: $color-action !important;
    border-radius: 3.5rem;
    height: calc(3.5rem - 2px);
    left: calc(-2.25rem + 1px);
    outline: 0 !important;
    top: calc(0.25rem + 1px);
    width: calc(3.5rem - 2px);
  }

  &.isSubscription {
    &::before {
      background: rgba($color-primary-one-wo-rgb, 0.22) !important;
      box-shadow: inset 0 4px 4px rgba($color-black-wo-rgb, 0.06);
    }
    &::after {
      left: calc(-0.25rem + 3px);
    }
  }
}
.row {
  margin-bottom: 3rem;
}

.remove {
  background-color: $color-error-dark;
}
.select-error {
  border: 1px solid $color-error-dark;
}

label {
  margin-bottom: 0;
}

.panel-footer {
  align-items: center;
  background-color: $color-black-one;
  border-radius: $size-input-border-radius;
  bottom: 7.5rem;
  display: flex;
  justify-content: flex-end;
  padding: 1rem 2rem;
  position: fixed;
  width: 94%;
  z-index: 9999;

  .svg-inline--fa {
    // position: absolute;
    // right: 18%;
  }
  &.form-error {
    background-color: $color-error-dark;
  }

  .divider-vertical {
    border-left: 1px solid white;
    height: 2.5rem;
    opacity: 0.4;
  }

  .btn-primary {
    &:active {
      background: rgba($color-white-wo-rgb, 0.1);
      color: white;
    }

    &:focus {
      background: transparent;
      color: white;
    }

    &:not(:disabled):not(.disabled) {
      &:active {
        background: rgba($color-white-wo-rgb, 0.1);
        color: white;
      }

      &:focus {
        background: transparent;
        color: white;
      }
    }
  }

  .btn-clear {
    color: white;
    padding-left: 1rem !important;
  }

  .btn-cancel {
    padding-left: 1rem !important;
  }
}

.v-select {
  ::v-deep .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

.error {
  color: red;
}
</style>
